import React from 'react'
import PropTypes from 'prop-types'

import Checkbox from '../Checkbox'

const TableRows = ({
  tablePayload,
  activeColumns,
  starColumn,
  isHeaderVisible,
  UUIDCheckboxes,
  styleCallback,
  loading
}) => {
  const renderCheckboxCell = (row, index) => {
    const isTextWrap = tablePayload.textWrap?.includes(row.name)
    const toggleTextWrap = () => {
      if (isTextWrap) {
        tablePayload.setTextWrap((columns) => columns.filter((x) => x !== row.name))
      } else {
        tablePayload.setTextWrap([...tablePayload.textWrap, row.name])
      }
    }

    return <>
      <div className={`td d-flex justify-content-between align-items-center pe-2 flex-wrap ${tablePayload.selected.includes(row.uuid) ? 'active-bg' : ''} ${tablePayload.stickyColumn ? 'sticky-col' : ''}`}>
        <span>
          <Checkbox
            name={`checkbox-${index}`}
            checked={tablePayload.selected.includes(row.uuid)}
            onChange={() => tablePayload.setSelected(row.uuid)}
          />
        </span>
        {/* {starColumn &&
          <span className="star-checkbox text-muted mb-1 pe-1">
            <input type="checkbox" id={`star-checkbox-${index}`} name={`star-checkbox-${index}`}
              onChange={() => tablePayload.setStarred(row.uuid)}
              checked={tablePayload.starred.includes(row.uuid)}
            />
            <label htmlFor={`star-checkbox-${index}`} />
          </span>
        } */}
      </div>
      {tablePayload.stickyColumn && (
        <div
          className={`sticky-col td d-flex align-items-center flex-wrap ${tablePayload.selected.includes(row.uuid) ? 'active-bg' : ''} ${!tablePayload.stickyColumn?.render ? 'p-2' : 'p-0'}`}
          style={{
            boxShadow: tablePayload.stickyColumn ? '4px 0px 10px -3px #d4d4d4' : '',
            left: tablePayload.stickyColumn ? '45px' : '',
            zIndex: tablePayload.stickyColumn ? '1' : ''
          }}
        >
          {
            tablePayload.stickyColumn?.render
              ? tablePayload.stickyColumn?.render(row, row[tablePayload.stickyColumn?.name], toggleTextWrap)
              : <span className={isTextWrap ? '' : 'text-truncate'}>{(row[tablePayload.stickyColumn?.name])}</span>
          }
        </div>
      )}
    </>
  }

  const renderStickyCellWithNoCheckbox = (row) => {
    const isTextWrap = tablePayload.textWrap?.includes(row.name)
    const toggleTextWrap = () => {
      if (isTextWrap) {
        tablePayload.setTextWrap((columns) => columns.filter((x) => x !== row.name))
      } else {
        tablePayload.setTextWrap([...tablePayload.textWrap, row.name])
      }
    }

    return (
      <div
        className={`sticky-col td d-flex align-items-center flex-wrap ${tablePayload.selected.includes(row.uuid) ? 'active-bg' : ''} ${!tablePayload.stickyColumn?.render ? 'p-2' : 'p-0'}`}
        style={{
          boxShadow: tablePayload.stickyColumn ? '4px 0px 10px -3px #d4d4d4' : '',
          left: tablePayload.stickyColumn ? '0' : '',
          zIndex: tablePayload.stickyColumn ? '1' : ''
        }}
      >
        {tablePayload.stickyColumn?.render
          ? tablePayload.stickyColumn?.render(row, row[tablePayload.stickyColumn?.name], toggleTextWrap)
          : <span className={isTextWrap ? '' : 'text-truncate'}>{(row[tablePayload.stickyColumn?.name])}</span>
        }
      </div>
    )
  }

  const renderDataCells = (row) => activeColumns.map((d, index) => {
    const isTextWrap = tablePayload.textWrap?.includes(d.name)
    const toggleTextWrap = () => {
      if (isTextWrap) {
        tablePayload.setTextWrap((columns) => columns.filter((x) => x !== d.name))
      } else {
        tablePayload.setTextWrap([...tablePayload.textWrap, d.name])
      }
    }

    return (
      <div
        key={index}
        name={d.name}
        className={`td ${tablePayload.selected.includes(row.uuid) ? 'active-bg' : ''} d-flex flex-wrap align-items-center ${d.isOptionColumn ? 'justify-content-end' : 'justify-content-between'} ${!d.render ? 'p-2' : 'p-0'}`}
      >
        {d.render
          ? d.render(row, isTextWrap, toggleTextWrap)
          : <span className={isTextWrap ? '' : 'text-truncate'}>{row[d.name]}</span>
        }
      </div>
    )
  })

  // Skeleton Table
  if (loading && tablePayload.assembledDataLength === 0) {
    // eslint-disable-next-line react/prop-types
    const SkeletonTD = ({ index }) => (
      <div className='td p-3'>
        <div className='skeleton' style={{
          borderRadius: '9px',
          height: '12px',
          width: index % 3 === 0
            ? '100%'
            : index % 3 === 1
              ? '85%'
              : '70%'
        }}>
          <span />
        </div>
      </div>
    )

    return (
      <div className='tbody'>
        {[...Array(tablePayload.rowsPerPage)].map((row, index) => (
          <div
            key={index}
            className={styleCallback
              ? `tr ${styleCallback(row)}`.trim()
              : 'tr'
            }
          >
            {isHeaderVisible && UUIDCheckboxes && <SkeletonTD index={index} />}
            {!UUIDCheckboxes && tablePayload.stickyColumn && <SkeletonTD index={index} />}
            {activeColumns.map((d, i) => <SkeletonTD key={i} index={index} />)}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className='tbody'>
      {tablePayload.visibleData.map((row, index) => (
        <div
          key={index}
          className={styleCallback
            ? `tr ${styleCallback(row)}`.trim()
            : 'tr'
          }
        >
          {isHeaderVisible && UUIDCheckboxes && renderCheckboxCell(row, index)}
          {!UUIDCheckboxes && tablePayload.stickyColumn && renderStickyCellWithNoCheckbox(row)}
          {renderDataCells(row)}
        </div>
      ))}
    </div>
  )
}

TableRows.propTypes = {
  isHeaderVisible: PropTypes.bool,
  activeColumns: PropTypes.array,
  tablePayload: PropTypes.object,
  starColumn: PropTypes.bool,
  UUIDCheckboxes: PropTypes.bool,
  styleCallback: PropTypes.func,
  loading: PropTypes.bool
}

export default TableRows
